import React from 'react'
import { projects } from '../../utils/projectData'
import Navbar from '../../components/navbar/Navbar'

const ProjectsPage = () => {
  return (
    <div>
        <Navbar page='all-projects' />
        <div className='p-4'>
            <div className='container'>
                <div className='align-items-center'>
                    <h1 className='fw-bolder'>My <span className='fw-medium fst-italic text-warning'>Projects</span></h1>
                </div>
                <div className='projectsWrapper row justify-content-center pt-5 gap-5'>
                    {
                        projects.map(project => {
                            return(
                                <div className="card bg-body-secondary col-md-4 border-0 shadow" style={{ width: '400px' }}>
                                    <div style={{overflow: "hidden"}}>
                                        <img src={project.image} className="card-img-top img-project" alt="..." style={{ height: '200px'}}/>
                                    </div>
                                    <div className="card-body">
                                    <div className='justify-content-center gap-2 row p-2'>
                                        {project.tags.map(tag => <div className='col badge text-bg-warning rounded-pill'>{tag}</div>)}
                                    </div>
                                    <div className='row p-2'>
                                        <p className="card-text col-8 fs-3 fw-bolder text-secondary">{project.title}</p>
                                        <a className='col' href={project.url} target="_blank" rel="noopener noreferrer">
                                            <button className=' btn btn-primary text-light fs-2 rounded-3'>&rarr;</button>
                                        </a>
                                    </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    </div>
  )
}

export default ProjectsPage